import React, { useEffect, useRef, useState } from "react";
import { Terminal, ChevronUp, ChevronDown, X } from "lucide-react";
import { useOmniCraftStore } from "./store";

export default function TerminalDrawer() {
  const terminal = useOmniCraftStore((s) => s.terminal);
  const clearLogs = useOmniCraftStore((s) => s.clearLogs);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [terminal, open]);

  return (
    <div
      className="border-t border-white/10 bg-[#05070A] text-white"
      data-testid="omnicraft-terminal"
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-3 py-1.5 hover:bg-white/[0.02]"
      >
        <Terminal size={11} className="text-emerald-400" />
        <span className="text-[10px] uppercase tracking-wider text-white/50">Terminal</span>
        <span className="text-[10px] text-white/30 font-mono">{terminal.length} lines</span>
        <div className="flex-1" />
        {open ? <ChevronDown size={12} className="text-white/40" /> : <ChevronUp size={12} className="text-white/40" />}
      </button>
      {open && (
        <div className="border-t border-white/10">
          <div className="px-3 py-1 flex justify-end">
            <button
              onClick={clearLogs}
              className="text-[10px] text-white/40 hover:text-white/70 flex items-center gap-1"
            >
              <X size={9} /> clear
            </button>
          </div>
          <div
            ref={ref}
            className="h-40 overflow-y-auto px-3 pb-2 font-mono text-[11px] text-white/70 space-y-0.5"
          >
            {terminal.length === 0 && (
              <div className="text-white/30 italic">idle · waiting for events</div>
            )}
            {terminal.map((row, i) => (
              <div key={i} className="whitespace-pre-wrap break-all">
                <span className="text-white/30 mr-2">
                  {new Date(row.t).toLocaleTimeString([], { hour12: false })}
                </span>
                {row.line}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
